import ProductPagination from '@app/plp/components/ProductPagination/ProductPagination';

export default ProductPagination;
